import { Star, ArrowUpRight, ArrowDownRight, Minus } from "lucide-react";
import { hotColor } from "./ProbabilityWidget";

export function BestBets({ bets = [] }) {
  if (!bets.length) return null;
  const sorted = [...bets].sort((a, b) => b.probability - a.probability);
  return (
    <div className="surface-raised p-6" data-testid="best-bets">
      <div className="label mb-5 flex items-center gap-2"><Star size={12} strokeWidth={1.5} /> Pronostici Consigliati</div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {sorted.map((b, i) => (
          <div key={`${b.market}-${b.pick}`} className={`p-4 border ${i === 0 ? "border-[#39FF14] bg-[#39FF14]/5" : "border-[#27272A]"}`} data-testid={`best-bet-${i}`}>
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <div className="label text-[10px]">{b.market}</div>
                <div className="heading text-2xl font-black mt-1">{b.pick}</div>
              </div>
              <div className="text-right shrink-0">
                <div className="heading text-3xl font-black mono" style={{ color: hotColor(b.probability) }}>{b.probability}%</div>
                <div className="label text-[9px]">Fattibilità</div>
              </div>
            </div>
            <p className="text-xs text-[#A1A1AA] mt-2 leading-relaxed">{b.reasoning}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

const CODE_LABEL = (c) =>
  ({ "1": "Esito 1", X: "Esito X", "2": "Esito 2", GG: "Goal" })[c] ||
  (c.startsWith("CO") ? `Corner Over ${c.slice(2)}` : c.startsWith("KO") ? `Cartellini Over ${c.slice(2)}` : c.startsWith("O") ? `Over ${c.slice(1)}` : `Doppia chance ${c}`);

export function ModelEvidence({ model }) {
  if (!model?.rows?.length) return null;
  return (
    <div className="surface-raised p-6" data-testid="model-evidence">
      <div className="label mb-1">Statistiche usate · modello + AI</div>
      <p className="text-[11px] text-[#71717A] mb-5">
        Ultime {model.sample.home} gare casa e {model.sample.away} ospite · gol attesi {model.expected.goals_home}-{model.expected.goals_away}
        {model.expected.corners != null && ` · corner attesi ${model.expected.corners}`}
        {model.expected.cards != null && ` · cartellini attesi ${model.expected.cards}`}
      </p>
      <div className="divide-y divide-[#27272A]">
        {model.rows.map((r) => (
          <div key={r.code} className="py-2.5 flex items-start gap-3" data-testid={`model-row-${r.code}`}>
            <div className="min-w-0 flex-1">
              <div className="text-sm font-bold">{CODE_LABEL(r.code)}</div>
              <div className="text-[10px] mono text-[#71717A] leading-snug">{r.evidence}</div>
            </div>
            <div className="text-right shrink-0">
              <div className="mono font-black" style={{ color: hotColor(r.final) }}>{r.final}%</div>
              <div className="text-[9px] mono text-[#71717A]">mod {r.model}% · AI {r.ai}%</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const IMPACT = {
  positivo: { icon: ArrowUpRight, color: "#39FF14" },
  negativo: { icon: ArrowDownRight, color: "#FF3B30" },
  neutro: { icon: Minus, color: "#A1A1AA" },
};

export function Factors({ factors = [], homeName, awayName }) {
  if (!factors.length) return null;
  const team = { home: homeName, away: awayName, both: "Entrambe" };
  return (
    <div className="surface-raised p-6" data-testid="factors-card">
      <div className="label mb-5">Fattori Chiave</div>
      <div className="space-y-3">
        {factors.map((f) => {
          const { icon: Icon, color } = IMPACT[f.impact] || IMPACT.neutro;
          return (
            <div key={`${f.label}-${f.team}-${f.text}`} className="flex gap-3">
              <Icon size={16} strokeWidth={2} color={color} className="shrink-0 mt-0.5" />
              <div className="min-w-0">
                <div className="text-sm font-bold">{f.label} <span className="label text-[9px] ml-1">{team[f.team] || ""}</span></div>
                <div className="text-xs text-[#A1A1AA] leading-relaxed">{f.text}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
